export default __webpack_public_path__ + "static/featuresListItem12-6cc645487c7cff433bfdcde2f7ac037d.svg";